import React from 'react'
import {useDispatch} from 'react-redux'
import {
  styled,
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@material-ui/core'
import {useOrganizationTypesState} from 'lms/hooks'
import {useCurrentSearchFilters} from 'searches/hooks'
import {updateCurrentSearchFilters} from 'searches/store/actions'

const Content = styled('fieldset')(({theme}) => ({
  margin: 0,
  marginTop: theme.spacing(1),
  borderColor: 'rgba(0, 0, 0, 0.23)',
  borderStyle: 'solid',
  borderWidth: 1,
  borderRadius: theme.shape.borderRadius,
}))

const Legend = styled('legend')(({theme}) => ({
  padding: 5,
  fontSize: 12,
  color: theme.palette.text.secondary,
}))

const Grid = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

const FormControlLabel = styled(MuiFormControlLabel)({})

const nameSorter = (a, b) => a.name.localeCompare(b.name)

const OrganizationTypes = (props) => {
  const {status, data} = useOrganizationTypesState()
  const {organizationTypes} = useCurrentSearchFilters()
  const dispatchRedux = useDispatch()

  if (status !== 'succeeded') return null

  const sortedOrganizationTypes = data.allIds
    .map(id => data.byId[id])
    .filter(ot => !ot.hidden)
    .sort(nameSorter)

  const toggle = (id, checked) => {
    const set = new Set(organizationTypes)
    checked ? set.add(id) : set.delete(id)
    dispatchRedux(updateCurrentSearchFilters({organizationTypes: Array.from(set)}))
  }

  return (
    <Content {...props}>
      <Legend>Organization Type</Legend>
      <Grid>
        {sortedOrganizationTypes.map((orgType) => (
          <FormControlLabel
            key={orgType.id}
            label={orgType.name}
            control={
              <MuiCheckbox
                checked={organizationTypes.includes(orgType.id)}
                onChange={(e, checked) => toggle(orgType.id, checked)}
              />
            }
          />
        ))}
      </Grid>
    </Content>
  )
}

export default OrganizationTypes
